import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { formatPrice } from "../utils/helpers";

const OutfitMenuItem = (props: any) => {
  const { className, id, brand, image_url, name, price, category } = props;
  return (
    <Link to={`/products/${id}`} target="_blank" rel="noopener noreferrer">
      <Wrapper className={className}>
        <div className="productImage">
          <img src={image_url} alt={name} />
        </div>
        <div className="productInfo">
          <p>{`${brand} ${name}`}</p>
          <p>{formatPrice(price)}</p>
        </div>
      </Wrapper>
    </Link>
  );
};

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 30px;

  .rowContainer {
    display: flex;
  }

  .productImage {
    img {
      width: 100%;
      height: 200px;
      object-fit: contain;
      background: #f5f5f5;
    }
  }

  .productInfo {
    padding-left: 1.5rem;
    font-family: HelveticaNeue-Medium;
    font-size: 18px;
    color: #1d1d1d;

    p {
      margin-top: 0;
      margin-bottom: 18px;
    }
  }
`;

export default OutfitMenuItem;
